export enum UserAuthenticationType {
    NA = 'NA',
    BearerOnly = "BearerOnly",
    APIOnly = "APIOnly",
    BearerAndAPI = "BearerAndAPI",
  }